import { resendSignUpCode } from "aws-amplify/auth";
import { authBus } from "../AuthEvents";

export const resendConfirmationCode = async (email: string): Promise<void> => {
  try {
    // V6 functional API - only needs the username (email)
    const { destination } = await resendSignUpCode({ username: email });

    authBus.emitMessage(`Code sent to ${destination}. Please check your email.`, "success");
  } catch (error: any) {
    let userMessage = "An error occurred sending the code. Please try again.";

    switch (error.name) {
      case "CodeDeliveryFailureException":
        userMessage = "We could not send the code to this email. Please check the address and try again.";
        break;
      case "LimitExceededException":
      case "TooManyRequestsException":
        userMessage = "Too many requests. Please wait a minute and try again.";
        break;
      case "UserNotFoundException":
        userMessage = "No user found with that email address.";
        break;
      default:
        userMessage = error.message || userMessage;
        break;
    }

    authBus.emitMessage(userMessage, "error");
  }
};
